import { rankToolResults } from "./tool-search-core.js";

const root = document.querySelector("[data-tool-search]");

if (root) {
  const trigger = root.querySelector("[data-tool-search-trigger]");
  const panel = root.querySelector("[data-tool-search-panel]");
  const closeButton = root.querySelector("[data-tool-search-close]");
  const input = root.querySelector("[data-tool-search-input]");
  const status = root.querySelector("[data-tool-search-status]");
  const empty = root.querySelector("[data-tool-search-empty]");
  const tools = Array.from(root.querySelectorAll("[data-tool-search-result]")).map((element, index) => ({
    element,
    index,
    name: element.dataset.name || "",
    category: element.dataset.category || "",
    search: element.dataset.search || ""
  }));
  let visibleTools = tools;

  const render = () => {
    visibleTools = rankToolResults(tools, input.value);
    const visibleElements = new Set(visibleTools.map(tool => tool.element));

    tools.forEach(tool => {
      tool.element.hidden = !visibleElements.has(tool.element);
      tool.element.style.order = visibleElements.has(tool.element)
        ? String(visibleTools.indexOf(tool))
        : "";
    });

    const count = visibleTools.length;
    const hasQuery = input.value.trim().length > 0;
    status.textContent = hasQuery
      ? `${count} matching ${count === 1 ? "tool" : "tools"}`
      : `${count} ${count === 1 ? "tool" : "tools"} available`;
    empty.hidden = count !== 0;
  };

  const closeSearch = (restoreFocus = false) => {
    if (panel.hidden) return;
    panel.hidden = true;
    trigger.setAttribute("aria-expanded", "false");
    if (restoreFocus) trigger.focus();
  };

  const openSearch = () => {
    window.dispatchEvent(new Event("toolbox:close-navigation"));
    panel.hidden = false;
    trigger.setAttribute("aria-expanded", "true");
    render();
    input.focus();
    input.select();
  };

  const isEditable = target =>
    target instanceof HTMLInputElement
    || target instanceof HTMLTextAreaElement
    || target instanceof HTMLSelectElement
    || target?.isContentEditable;

  trigger.addEventListener("click", () => {
    if (panel.hidden) openSearch();
    else closeSearch(true);
  });
  closeButton.addEventListener("click", () => closeSearch(true));
  document.querySelectorAll("[data-tool-menu-open-search]").forEach(button => {
    button.addEventListener("click", event => {
      event.stopPropagation();
      openSearch();
    });
  });
  input.addEventListener("input", render);
  input.addEventListener("keydown", event => {
    if (event.key === "ArrowDown" && visibleTools.length) {
      event.preventDefault();
      event.stopPropagation();
      visibleTools[0].element.focus();
    }
  });

  root.addEventListener("keydown", event => {
    const currentIndex = visibleTools.findIndex(tool => tool.element === document.activeElement);
    if (currentIndex < 0 || !["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) return;

    event.preventDefault();
    let nextIndex;
    if (event.key === "Home") nextIndex = 0;
    else if (event.key === "End") nextIndex = visibleTools.length - 1;
    else if (event.key === "ArrowDown") nextIndex = (currentIndex + 1) % visibleTools.length;
    else nextIndex = (currentIndex - 1 + visibleTools.length) % visibleTools.length;
    visibleTools[nextIndex].element.focus();
  });

  document.addEventListener("click", event => {
    if (!root.contains(event.target)) closeSearch();
  });
  document.addEventListener("keydown", event => {
    if (event.key === "Escape" && !panel.hidden) {
      event.preventDefault();
      closeSearch(true);
      return;
    }

    const isShortcut = event.key === "/" && !event.metaKey && !event.ctrlKey && !event.altKey
      || event.key.toLocaleLowerCase() === "k" && (event.metaKey || event.ctrlKey);
    if (isShortcut && !isEditable(event.target)) {
      event.preventDefault();
      openSearch();
    }
  });
  window.addEventListener("toolbox:close-tool-search", () => closeSearch());
}

const directoryRoot = document.querySelector("[data-tool-directory-search]");

if (directoryRoot) {
  const input = directoryRoot.querySelector("[data-tool-directory-input]");
  const clear = directoryRoot.querySelector("[data-tool-directory-clear]");
  const status = directoryRoot.querySelector("[data-tool-directory-status]");
  const results = directoryRoot.querySelector("[data-tool-directory-results]");
  const empty = directoryRoot.querySelector("[data-tool-directory-empty]");
  const categories = document.querySelector("[data-tool-directory-categories]");
  const tools = Array.from(directoryRoot.querySelectorAll("[data-tool-directory-result]")).map((element, index) => ({
    element,
    index,
    name: element.dataset.name || "",
    category: element.dataset.category || "",
    search: element.dataset.search || ""
  }));
  let visibleTools = tools;

  const renderDirectorySearch = () => {
    const hasQuery = input.value.trim().length > 0;
    visibleTools = hasQuery ? rankToolResults(tools, input.value) : tools;
    const visibleElements = new Set(visibleTools.map(tool => tool.element));

    tools.forEach(tool => {
      tool.element.hidden = !hasQuery || !visibleElements.has(tool.element);
      tool.element.style.order = hasQuery && visibleElements.has(tool.element)
        ? String(visibleTools.indexOf(tool))
        : "";
    });

    categories.hidden = hasQuery;
    results.hidden = !hasQuery;
    clear.hidden = !hasQuery;
    empty.hidden = !hasQuery || visibleTools.length !== 0;
    const count = visibleTools.length;
    status.textContent = hasQuery
      ? `${count} matching ${count === 1 ? "tool" : "tools"}`
      : `${tools.length} tools available`;
  };

  input.addEventListener("input", renderDirectorySearch);
  input.addEventListener("keydown", event => {
    if (event.key === "Escape" && input.value) {
      event.preventDefault();
      input.value = "";
      renderDirectorySearch();
    } else if (event.key === "ArrowDown" && visibleTools.length && input.value.trim()) {
      event.preventDefault();
      visibleTools[0].element.querySelector("a")?.focus();
    }
  });
  clear.addEventListener("click", () => {
    input.value = "";
    renderDirectorySearch();
    input.focus();
  });
  renderDirectorySearch();
}
